import { settings } from "../settings";
import { impersonateUserEndpoint } from "./impersonationEndpoints";
import { fetchImpersonatedEmail } from "./ImpersonationStatusService";

const { auth0DomainApiV2 } = settings;

// The function app returns { message: '...' } on a failure. Older deploys and gateway errors
// return no body, so fall back to the generic alert text.
async function readErrorMessage(response) {
    try {
        const body = await response.json();
        return body && typeof body.message === 'string' && body.message.trim() ? body.message.trim() : null;
    } catch (e) {
        return null;
    }
}

export async function ImpersonateService(getAccessTokenSilently, emailToImpersonate, handleAlert, handleInvalidEmail, handleIsLoading, goToSummary) {

    handleIsLoading(true);

    try {
        const token = await getAccessTokenSilently({
            audience: auth0DomainApiV2,
            scope: 'write:app_metadata',
        });
        
        const response = await fetch(impersonateUserEndpoint(emailToImpersonate), {
            headers: {
                Authorization: `Bearer ${token}`,
                'X-CLIENT-TYPE': 'Bespoke',
                'X-APP-LOCALE': 'en-GB',

            }
        })

        if(response.status === 200){
            // Show the email the backend stored - the Auth0 profile's own casing, as the home page
            // shows after a log out and in - not the typed one, so the two always match. The old
            // host stores nothing, so fall back to what was typed there.
            const impersonatedEmail = (await fetchImpersonatedEmail(getAccessTokenSilently)) ?? emailToImpersonate;
            handleAlert('success', `Success! You are now impersonating ${impersonatedEmail}.`)
            goToSummary(impersonatedEmail);
          } else {
            // Show the reason the function gave. A missing Auth0 profile is not a typo in the
            // form, so handleInvalidEmail() is only for a real format problem (BUG-142).
            const reason = await readErrorMessage(response);
            handleAlert('error', reason ? `Error! ${reason}` : `Error! Failed to impersonate user.`);
            if(!reason){
                handleInvalidEmail();
            }
          }

    } catch (e) {
        console.error(e);
        handleIsLoading(false);
    }
    
    handleIsLoading(false);
}
